export const EXCHANGE_RATES_SLICE_NAME = '@@exchangeRates';
